import React from 'react';

import MUIRadio, { RadioProps as MUIRadioProps } from '@material-ui/core/Radio';

interface RadioProps extends MUIRadioProps {}

const Radio = (props: RadioProps) => {
  return <MUIRadio color="primary" {...props} />;
};

Radio.displayName = 'Radio';

export default Radio;
